import { useI18n } from 'vue-i18n';

export function useDate() {
  const { t, locale } = useI18n();

  function getClosestAvailabilityDate(date: string | null) {
    const now = new Date();
    const closestDate = date ? new Date(date) : null;

    if (closestDate && closestDate > now) {
      const formattedDate = closestDate.toLocaleDateString(locale.value, {
        year: 'numeric',
        month: 'long'
      });
      
      return formattedDate;
    }
    
    return t('common.rightNow');
  }

  return {
    getClosestAvailabilityDate
  };
}